import React from 'react';
import {GqlListContent, getListContentClass} from './commonUtil';

const getGqlCompletePageBody = (userType, translations) => {
    const gqlPageData = {
        IPM: [
            {
                parentBullet: translations['ipmob.gql.netnew.complete.dialog.list.content_1'],
                childBullets: []
            },
            {
                parentBullet: translations['ipmob.gql.netnew.complete.dialog.list.content_2'],
                childBullets: []
            },
            {
                parentBullet: translations['ipmob.gql.netnew.complete.dialog.list.content_3'],
                childBullets: []
            },
            {
                parentBullet: translations['ipmob.gql.netnew.complete.dialog.list.content_4'],
                childBullets: [
                    translations['ipmob.gql.netnew.complete.dialog.list.content_4.child.1'],
                    translations['ipmob.gql.netnew.complete.dialog.list.content_4.child.2']
                ]
            },
            {
                parentBullet: translations['ipmob.gql.netnew.complete.dialog.list.content_5'],
                childBullets: [
                    translations['ipmob.gql.netnew.complete.dialog.list.content_5.child.1'],
                    translations['ipmob.gql.netnew.complete.dialog.list.content_5.child.2']
                ]
            }
        ],
        PPM: [
            {
                parentBullet: translations['ipmob.gql.complete.dialog.list_2.content_1'],
                childBullets: [
                    translations['ipmob.gql.complete.dialog.list_2.content_1.child.1']
                ]
            },
            {
                parentBullet: translations['ipmob.gql.complete.dialog.list_2.content_2'],
                childBullets: [
                    translations['ipmob.gql.complete.dialog.list_2.content_2.child.1'],
                    translations['ipmob.gql.complete.dialog.list_2.content_2.child.2']
                ]
            },
            {
                parentBullet: translations['ipmob.gql.complete.dialog.list_2.content_3'],
                childBullets: [
                    translations['ipmob.gql.complete.dialog.list_2.content_3.child.1']
                ]
            }
        ],
        IPM_SOFTWARE_SWITCH: [
            {
                parentBullet: translations['ipmob.gql.ssx.complete.dialog.list.content_1'],
                childBullets: []
            },
            {
                parentBullet: translations['ipmob.gql.ssx.complete.dialog.list.content_2'],
                childBullets: [
                    translations['ipmob.gql.ssx.complete.dialog.list.content_2.child.1']
                ]
            },
            {
                parentBullet: translations['ipmob.gql.ssx.complete.dialog.list.content_3'],
                childBullets: []
            },
            {
                parentBullet: translations['ipmob.gql.ssx.complete.dialog.list.content_4'],
                childBullets: [
                    translations['ipmob.gql.ssx.complete.dialog.list.content_4.child.1']
                ]
            }
        ]
    };

    return gqlPageData[userType] || [];
}

const getGqlCompletePageListContent = (userType, translations) => {
    const gqlCompletePageBody = getGqlCompletePageBody(userType, translations)
    const listItemClass = getListContentClass(userType)

    return (
        <div className="complete-page-content">
            <GqlListContent
                userType={userType}
                contentList={gqlCompletePageBody}
                translations={translations}
                listItemClass={listItemClass}
            />
        </div>
    )
}

const getGqlCompletePageContent = (userType, translations) => {
    const heading = userType === 'IPM_SOFTWARE_SWITCH' ?
        translations['ipmob.gql.ssx.complete.heading.1'] :
        translations['ipmob.gql.complete.heading.1']

    const footer = userType === 'IPM_SOFTWARE_SWITCH' ? {
        footer_1: translations['ipmob.gql.ssx.complete.footer_1'],
        footer_2: translations['ipmob.gql.complete.footer_2'],
    } : {
        footer_1: translations['ipmob.gql.complete.footer_1'],
        footer_2: translations['ipmob.gql.complete.footer_2'],
    }

    return {
        heading,
        contents: getGqlCompletePageListContent(userType, translations),
        footer
    }
}

export {getGqlCompletePageContent};
